"use client";
import styles from "./ErrorPromo.module.scss";
import { Container } from "components/layout/Container";
import { Button } from "components/UI/buttons/Button";
import { Heading } from "components/UI/typography/Heading";
import { useEffect } from "react";

export const ErrorPromo = ({
  heading,
  subheading,
  btnText = "Go home",
  btnLink = "/",
}: {
  heading: string;
  subheading: string;
  btnText?: string;
  btnLink?: string;
}) => {
  // workaround for sprite mounting
  useEffect(() => {
    // @ts-ignore
    const sprite = window["__SVG_SPRITE__"];
    // sprite.mount(document.body, true);

    const spriteElement = document.getElementById("__SVG_SPRITE_NODE__");

    if (sprite && !spriteElement) {
      document.body.insertBefore(sprite.node, document.body.firstChild);
    }
  }, []);

  return (
    <section className={styles.section}>
      <Container className={styles.container}>
        <div className={styles.content}>
          <Heading level={1} className={styles.heading} html={heading} />
          <p className={styles.subheading} dangerouslySetInnerHTML={{ __html: subheading }} />
        </div>
        <Button tag="internalLink" href={btnLink} type="accent">
          {btnText}
        </Button>
      </Container>
    </section>
  );
};
